/**
 * 基础菜单 商品管理
 */
<template>
  <dataList v-bind:child-msg="data"></dataList>
</template>

<script>
import dataList from '../../components/dataList'
import { userList } from '../../api/userMG'
export default {
  data() {
    return {
      data: {
        dbName: 'patient',
        breadcrumb: 'User List',
        bool : false,
        serialNumberBool: false,
        type: 'selection',
        assignBelonging: ['YES', 'NO'],
        statusArr: ['Working', 'Online', 'Offline', 'Disable'],
        data: [
          {
            prop:'firstName',
            label:'First Name',
           },
          {
            prop:'lastName',
            label:'Last Name',
           },
          {
            prop:'sex',
            label:'Gender',
           },
          {
            prop:'belonging',
            label:'Beauty center'
           },
          {
            prop:'tel',
            label:'Tel.',
           },
          {
            prop:'creationTime',
            label:'Creation time',
          }
        ]
      }
    }
  },
  // 注册组件
  components: {
    dataList
  },
  /**
   * 创建完毕
   */
  created() {
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.serialnNmber-tag{
  width: 82%;
  min-height: 60px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
.el-drawer__body>* {
  box-sizing: border-box;
}
.el-tag.el-tag--info{
  margin-left: 10px;
}
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  padding: 20px;
  height: 100%;
}
.demo-drawer__footer{
  display: flex;
}
.demo-drawer__content form{
  flex: 1;
}
.demo-drawer__footer button{
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/patient/Patient.vue